import React from 'react'
import { useFormikContext } from 'formik'

import { Button } from '@components/Button'
import { CardFooter } from '@components/layout/Card'

export const Footer = () => {
  const { values, isValid, isSubmitting } = useFormikContext()
  const { selected_budget_type } = values

  return (
    <CardFooter>
      <Button disabled={!isValid || isSubmitting} type='submit'>
        {selected_budget_type === 'simple'
          ? 'Update and use simple expenses'
          : 'Update and use detailed expenses'
        }
      </Button>
    </CardFooter>
  )
}
